import React from 'react';
import PropTypes from 'prop-types';
import ResponseBox from './ResponseBox';
import { getBracket } from '../../../../utils/shared/probeDetailUtils';
import { PROBE_DETAIL } from '../../../../constants/shared/CommonConstants';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const { BREAK } = PROBE_DETAIL;

const ContentParagraph = props => {
    const { questions, selectedResponses, correctResponses, text, isSelected, showBracket } = props;
    const getResponseOptions = (questionIndex, index) => {
        const question = questions[questionIndex];
        return (
            <ResponseBox
                key={generateReactKey(index)}
                possibleResponses={question.possible_responses}
                selectedResponse={selectedResponses[questionIndex]}
                correctResponse={correctResponses[`item${questionIndex}`]}
                isSelected={isSelected}
            />
        );
    };
    const getTextWithBreak = line => {
        return line.split(BREAK).map((lineItem, index, charArray) => {
            const divider = index < charArray.length - 1 ? <br /> : null;
            return (
                <span key={generateReactKey(index)}>
                    {lineItem}
                    {divider}
                </span>
            );
        });
    };
    const renderTextWithBoxes = renderText =>
        renderText.map((snippet, index) => {
            if (snippet.length === 0 || typeof snippet !== 'number') {
                if (snippet.match(BREAK)) {
                    return getTextWithBreak(snippet);
                }
                return <span key={generateReactKey(index, snippet)}>{snippet}</span>;
            }
            return getResponseOptions(snippet, index);
        });
    return isSelected ? (
        <>
            {renderTextWithBoxes(text)}
            {getBracket(showBracket)}
        </>
    ) : (
        <span className="gray-color">{renderTextWithBoxes(text)}</span>
    );
};

ContentParagraph.defaultProps = {
    isSelected: false,
    showBracket: true,
};

ContentParagraph.propTypes = {
    questions: PropTypes.arrayOf(PropTypes.object).isRequired,
    text: PropTypes.array.isRequired,
    selectedResponses: PropTypes.array.isRequired,
    correctResponses: PropTypes.object.isRequired,
    isSelected: PropTypes.bool,
    showBracket: PropTypes.bool,
};

export default ContentParagraph;
